import React from "react";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Button } from "@mui/material";

export default function ButtonLink({ title, url }) {
  return (
    // <div className='btn'>
    //     <Link to={url} className="button_link" color="primary" sx={{ mt: 2 }}>
    //         {title}
    //     </Link>
    //     <NavigateNextIcon />
    // </div>
    <div className="btn">
      <Button
        color="primary"
        component={Link}
        to={url}
        sx={{ tetxcolor: "#43c5c0" }}
        className="button_link"
      >
        {title}
        <NavigateNextIcon />
      </Button>
    </div>
  );
}
